import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirdiairportcab() {



  const cardData = {
"keyword": "Pune to Shirdi Airport Cab",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Shirdi Airport Cab for travelers seeking safe, timely, and convenient long-distance airport transportation. Whether you are planning a pilgrimage to Shirdi Sai Baba Temple, business travel, family trip, or airport transfer connection via Shirdi Airport, our cab service ensures a smooth and stress-free journey. With experienced drivers who are well-versed with highway routes and airport timings, clean air-conditioned vehicles maintained for long-distance comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Shirdi Airport. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible one-way and round-trip options, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and punctual airport transfer experience.",

"topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description":
      "Shirdi Sai Baba Temple is one of India’s most important pilgrimage destinations dedicated to Sai Baba. Devotees from Pune travel here for darshan, aarti, and spiritual blessings, making it the central attraction near Shirdi Airport."
  },
  {
    "title": "Shirdi Airport (Shri Saibaba International Airport)",
    "description":
      "Shirdi Airport is a modern airport serving pilgrims and travelers visiting Shirdi and nearby regions. It provides improved connectivity for devotees and reduces travel time for those visiting Sai Baba Temple."
  },
  {
    "title": "Dwarkamai Mosque",
    "description":
      "Dwarkamai is a sacred place within the Shirdi temple complex where Sai Baba spent a major part of his life. It is a deeply spiritual site visited by thousands of devotees daily."
  },
  {
    "title": "Chavadi",
    "description":
      "Chavadi is another important site in Shirdi where Sai Baba used to rest on alternate nights. It holds historical and spiritual significance for pilgrims visiting from Pune."
  },
  {
    "title": "Shani Shingnapur Temple",
    "description":
      "Shani Shingnapur Temple is a famous pilgrimage site near Shirdi dedicated to Lord Shani, known for its unique open-air shrine and strong spiritual beliefs."
  },
  {
    "title": "Nashik Trimbakeshwar Route",
    "description":
      "The route between Pune and Shirdi often extends toward Nashik, home to Trimbakeshwar Jyotirlinga, making it a popular extended pilgrimage circuit for devotees."
  },
  {
    "title": "Rahata Village",
    "description":
      "Rahata is a nearby town to Shirdi known for accommodation, local markets, and connectivity for pilgrims traveling via Shirdi Airport and temple visits."
  },
  {
    "title": "Sai Heritage Village",
    "description":
      "Sai Heritage Village is a themed attraction near Shirdi showcasing the life and teachings of Sai Baba through cultural displays and exhibits."
  },
  {
    "title": "Lendi Baug",
    "description":
      "Lendi Baug is a peaceful garden in Shirdi associated with Sai Baba, known for its spiritual calmness and historical importance."
  },
  {
    "title": "Pune to Shirdi Highway Scenic Route",
    "description":
      "The Pune to Shirdi route via cab passes through smooth highways, rural Maharashtra landscapes, and devotional stopovers, offering a comfortable and scenic long-distance travel experience."
  }
],



services: [
  {
    name: "Pune to Shirdi Airport Cab",
    description: "Pune to Shirdi Airport cab service provides reliable transportation for passengers traveling between Pune and Shirdi Airport with comfortable vehicles and experienced drivers. Vehicles are suitable for long-distance highway travel ensuring smooth and timely journeys for families, tourists, pilgrims, and business travelers. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient Shirdi Airport cab reservations."
  },
  {
    name: "Pune to Shirdi Taxi",
    description: "Pune to Shirdi taxi service offers dependable transportation for Shirdi temple visits and airport transfers with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for pilgrimage trips, family travel, tourism, and business journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Shirdi taxi reservations."
  },
  {
    name: "Cab from Pune to Shirdi Airport",
    description: "Cab from Pune to Shirdi Airport service provides comfortable transportation for passengers traveling from Pune to Shirdi Airport and nearby pilgrimage destinations. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth airport transfer journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and nearby locations across Pune. Ideal for pilgrims, tourists, and family travel requirements. Flexible booking options allow convenient airport cab reservations."
  },
  {
    name: "Shirdi Airport Transfer Cab Pune",
    description: "Shirdi Airport transfer cab Pune service offers reliable transportation with comfortable vehicles and professional drivers for airport pickups and drops between Pune and Shirdi. Vehicles provide smooth highway travel suitable for tourism, pilgrimage visits, and family travel. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available directly from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy airport transfer cab reservations."
  },
  {
    name: "Pune to Shirdi Airport Taxi Service",
    description: "Pune to Shirdi Airport taxi service provides dependable transportation solutions for airport travel and pilgrimage journeys between Pune and Shirdi. Vehicles are suitable for long-distance travel ensuring safe and smooth journeys for individuals, families, and groups. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for business travel, temple visits, and family airport transfers. Flexible booking options allow convenient airport taxi reservations."
  },
  {
    name: "Best Pune to Shirdi Airport Cab",
    description: "Best Pune to Shirdi Airport cab service provides transparent and reliable transportation for travelers needing comfortable airport transfer services between Pune and Shirdi. Travelers can enjoy smooth journeys with experienced drivers familiar with highway routes and airport travel conditions. Comfortable vehicles ensure timely travel with safe transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient airport cab reservations."
  },
  {
    name: "Cheap Pune to Shirdi Airport Taxi",
    description: "Cheap Pune to Shirdi Airport taxi service provides economical transportation for travelers planning airport transfers and pilgrimage trips between Pune and Shirdi. Comfortable vehicles ensure smooth highway travel suitable for business trips, temple visits, and family travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient low-cost airport taxi reservations."
  },
  {
    name: "SUV Pune to Shirdi Airport Cab",
    description: "SUV Pune to Shirdi Airport cab service offers spacious transportation for families and groups traveling between Pune and Shirdi Airport. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for pilgrimage and airport travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient SUV airport cab reservations."
  },
  {
    name: "Innova Pune to Shirdi Airport Cab",
    description: "Innova Pune to Shirdi Airport cab service provides premium SUV transportation for passengers seeking comfortable and reliable airport transfer travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for tourism, pilgrimage trips, and family travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Innova airport cab reservations."
  },
  {
    name: "Sedan Pune to Shirdi Airport Taxi",
    description: "Sedan Pune to Shirdi Airport taxi service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Shirdi Airport. Sedan vehicles provide smooth highway travel with comfortable seating and luggage space suitable for airport transfer journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient sedan airport taxi reservations."
  },
  {
    name: "Pune Airport to Shirdi Cab",
    description: "Pune Airport to Shirdi cab service offers dependable transportation for passengers planning direct travel from Pune Airport to Shirdi and nearby pilgrimage destinations. Comfortable vehicles ensure smooth highway travel suitable for tourism, spiritual travel, and family trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available directly from Pune Airport, hotels, railway stations, and nearby locations across Pune. Flexible booking options allow convenient airport to Shirdi cab reservations."
  },
  {
    name: "Shirdi Airport Drop Cab Pune",
    description: "Shirdi Airport drop cab Pune service provides reliable transportation for travelers planning airport drop services from Pune to Shirdi Airport. Comfortable vehicles ensure smooth and safe travel suitable for tourists, families, business travelers, and pilgrims. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient airport drop cab reservations."
  },
  {
    name: "Pune to Shirdi Travel Cab",
    description: "Pune to Shirdi travel cab service offers comfortable transportation for passengers looking for reliable travel services between Pune and Shirdi. Vehicles ensure reliable local and highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for temple visits, business trips, family tours, and pilgrimage travel requirements. Flexible booking options allow convenient travel cab reservations."
  },
  {
    name: "Long Distance Airport Cab Pune",
    description: "Long distance airport cab Pune service provides dependable transportation for passengers planning long-distance airport transfers and outstation travel from Pune. Comfortable vehicles ensure smooth highway travel suitable for tourism, airport visits, and corporate travel. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient long-distance airport cab reservations."
  },
  {
    name: "Pune to Shirdi One Way Cab",
    description: "Pune to Shirdi one way cab service provides affordable and convenient one-side transportation for passengers traveling between Pune and Shirdi. Vehicles ensure reliable highway travel with experienced drivers offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for pilgrims, tourists, and one-way airport transfer requirements. Flexible booking options allow convenient one-way cab reservations."
  }
],

tableData: [
  ["Pune to Shirdi Airport Cab", "Pune to Shirdi Taxi"],
  ["Cab from Pune to Shirdi Airport", "Shirdi Airport Transfer Cab Pune"],
  ["Pune to Shirdi Airport Taxi Service", "Best Pune to Shirdi Airport Cab"],
  ["Cheap Pune to Shirdi Airport Taxi", "SUV Pune to Shirdi Airport Cab"],
  ["Innova Pune to Shirdi Airport Cab", "Sedan Pune to Shirdi Airport Taxi"],
  ["Pune Airport to Shirdi Cab", "Shirdi Airport Drop Cab Pune"],
  ["Pune to Shirdi Travel Cab", "Long Distance Airport Cab Pune"],
  ["Pune to Shirdi One Way Cab", "Pune to Shirdi Airport Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Shirdi Airport Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Shirdi Airport cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe airport travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Shirdi Airport Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Shirdi Airport cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Shirdi Airport Cab Availability",
        WhyChoosedescription: "Our Pune to Shirdi Airport cab service operates 24 hours a day for airport transfers, Sai Baba darshan trips, family travel, business travel, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Airport Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance airport travel experiences."
      },
      {
        WhyChooseheading: "One Way & Round Trip Airport Transfers",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Shirdi Airport taxi service, round-trip bookings, airport pickup and drop services, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, pilgrims, and group airport transfers."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Airport Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Shirdi Airport highway routes and ensure safe driving, smooth travel, and timely airport drop and pickup services."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Shirdi Airport cab service?", answer: "Pune to Shirdi Airport cab service provides comfortable taxi transportation between Pune and Shirdi Airport for airport transfers and pilgrimage travel." },
    { question: "Is Pune to Shirdi Airport cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Shirdi Airport cab service." },
    { question: "Which vehicles are available for Pune to Shirdi Airport travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Shirdi Airport?", answer: "Yes, customers can book one-way as well as round-trip Pune to Shirdi Airport taxi services." },
    { question: "Do you provide airport pickup and drop services?", answer: "Yes, Shivai Travels provides airport pickup and airport drop services for Shirdi Airport." },
    { question: "Are all Pune to Shirdi Airport taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance airport travel." },
    { question: "Can I book Pune to Shirdi Airport cab service online?", answer: "Yes, customers can easily book Pune to Shirdi Airport cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group airport travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family travel and group airport transfers." },
    { question: "Are Pune to Shirdi Airport cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Shirdi Airport cab service?", answer: "Yes, advance booking is available and recommended for flight schedules, weekends, and festive travel seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Sandeep Kulkarni",
      feedback:
        "Booked Pune to Shirdi Airport cab service with Shivai Travels. On-time pickup, comfortable vehicle, and smooth airport transfer experience.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Poonam Patil",
      feedback:
        "Excellent Pune to Shirdi Airport taxi service. Affordable pricing, clean cab, and very professional driver support.",
      rating: 5
    }
  ];











  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Airport Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-shirdi-airport-cab.jpg",
  "description": "Book Pune to Shirdi Airport cab service for safe and comfortable long-distance airport transfers. Shivai Travels offers reliable one-way and round-trip taxi service with sedan, SUV, Innova, and luxury cab options available 24x7 for Shirdi Airport travel and drop services.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-shirdi-airport-cab"
  }
};





  return (
    <div>

<Helmet>
  <title>Pune to Shirdi Airport Cab | Airport Transfer Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Shirdi Airport cab service for reliable long-distance airport transfers. Affordable one-way and round-trip taxi options with sedan, SUV, Innova, and luxury cabs available 24x7."
  />

  <meta
    name="keywords"
    content="pune to shirdi airport cab, pune to shirdi taxi, cab from pune to shirdi airport, shirdi airport transfer cab pune, pune to shirdi airport taxi service, best pune to shirdi airport cab, cheap pune to shirdi airport taxi, suv pune to shirdi airport cab, innova pune to shirdi airport cab, sedan pune to shirdi airport taxi, pune airport to shirdi cab, shirdi airport drop cab pune, pune to shirdi travel cab, long distance airport cab pune, pune to shirdi one way cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/68.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoshirdiairportcab;